module.exports = __webpack_public_path__ + "static/img/125.cbeb9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/125.png
// module id = Iw4f
// module chunks = 0